import React, {useEffect, useRef} from 'react'
import {useLocation, useParams} from 'react-router'
import ErrorPage from '../ErrorPage/ErrorPage'
import {useSelector, useDispatch} from 'react-redux'
import {Helmet} from 'react-helmet'
import {useGetGameMutation} from '../../../store/game/actions'
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from 'react-router-dom';

import './Game.css'
import {sendAnalytics} from '../../../utils/analytics'
import {setGame} from '../../../store/game/gameSlice'
import {CloseIcon} from '../../component/icones'
import {useState} from 'react'
import Draggable from 'react-draggable'
import {DragIndicatorIcon} from '../../component/icones'
import {Player} from '@lottiefiles/react-lottie-player'
import InterstitialAdComponent from "../../../components/InterstitialAdComponent";
import RewardedAdComponent from "../../../components/RewardedAdComponent";
import {useSearchParams} from "react-router-dom";
import LobbyRoom from "../../../components/lobbyRoom";
import {toast} from "react-hot-toast";
import {GameLoadingModal} from "../../../components/GameLoadingModal";
import {
    useRegisterPlayWithStrangerMutation,
    usePlayWithStrangerGameResultsMutation,
} from "../../../store/multiplayer/slice";
import {GameModeModal} from "../../../components/GameModeModal";
import axios from "axios";
import GameResultModal from "../../../components/resultModal";
import ResultLoadingModal from "../../../components/resultLoadingModal";
import {avatarImages, names} from "../../../utils/user-dummy-data";
import GameLoadingScreen from "../../../components/GameLoader";

const GAME_CONTROL_ICON_POSITION_STYLES = {
    "left-center": {top: "50%", left: 0, transform: "translateY(-50%)"},
    "right-center": {top: "50%", right: 0, transform: "translateY(-50%)"},
    "top-center": {top: 0, left: "50%", transform: "translateX(-50%)"},
    "bottom-center": {bottom: 0, left: "50%", transform: "translateX(-50%)"},
}

const getGameControlIconPositionStyle = (position) => {
    return GAME_CONTROL_ICON_POSITION_STYLES[position] || GAME_CONTROL_ICON_POSITION_STYLES["right-center"]
}

const Game = () => {
    const [thumbnail, setThumbnail] = useState(null);
    const dispatch = useDispatch()
    const [getGame, {isError}] = useGetGameMutation()
    const [registerPlayWithStranger, {isPWSError}] = useRegisterPlayWithStrangerMutation()
    const [showLoader, setShowLoader] = useState(true)
    const [gameProductId, setGameProductId] = useState(null)
    const [showInterstitialAd, setShowInterstitialAd] = useState()
    const [showVideoRewardedAd, setShowVideoRewardedAd] = useState(false)
    const game = useSelector(state => state.game)
    const location = useLocation()
    const {slug} = useParams()
    const [gameIframe, setGameIframe] = useState('')
    const showAds = process.env.REACT_APP_SHOW_ADS_FROM_PARAMS === "true" || process.env.REACT_APP_SHOW_ADS === "true"
    const [searchParams, setSearchParams] = useSearchParams();
    const [showResultModal, setShowResultModal] = useState(false);
    const [showGameIframe, setShowGameIframe] = useState(false);
    const [userId, setUserId] = useState('')
    const [name, setName] = useState('User')
    const [avatar, setAvatar] = useState('https://media.simpleviralgames.com/images/vip-avatars/ff05ae17-7570-4293-bbfa-0b7eec5f9a4e.png')
    const [pwsPlayers, setPwsPlayers] = useState([])
    const [showGameLoadingModal, setShowGameLoadingModal] = useState(false)
    const [mode, setMode] = useState("dark")
    const [joinPWSResponse, setJoinPWSResponse] = useState(false)
    const [isGameWon, setIsGameWon] = useState(false)
    const [roomCode, setRoomCode] = useState('')
    const [multiplayerGameResults, setMultiplayerGameResults] = useState([])
    const [showLobbyRoom, setShowLobbyRoom] = useState(false)
    const [showGameModeModal, setShowGameModeModal] = useState(true)
    const [showResultLoadingModal, setShowResultLoadingModal] = useState(false)
    const [gameServerUrl, setGameServerUrl] = useState('')
    const navigate = useNavigate();
    const [error, setError] = useState(null)
    const hasAutoJoinedMatchmaking = useRef(false)

    const startPWSGame = async () => {
        const queryParamData = {
            game_id: game?.data?.uuid,
            auth_type: 'basic',
            score_sync: game?.data?.score_sync,
            state_sync: game?.data?.state_sync,
            user_id: getUserIdFromParams(),
            client_id: process.env.REACT_APP_CLIENT_ID,
            tournament_mode: false,
            show_ads: false,
            show_purchase_options: process.env.REACT_APP_SHOW_ADS === "true" || (process.env.REACT_APP_SHOW_ADS_FROM_PARAMS === "true" && searchParams.get("showAds") === "true"),
            show_revive_button: false,
            show_share_button: false,
            show_in_game_controls: getShowInGameControlsFromParams(),
            is_business_platform: true
        }

        // Add meme_mode parameters if meme_mode is enabled and meme_mode=true in query params
        const memeModeFeatureEnabled = process.env.REACT_APP_MEME_MODE_FEATURE === "true";
        const memeModeParam = searchParams.get("meme_mode");
        
        if (memeModeFeatureEnabled && memeModeParam === "true") {
            queryParamData.meme_mode = "true";
            
            // Extract meme-related query parameters
            const memeBgImage = searchParams.get("memebg_image");
            const memePlayerImage = searchParams.get("memeplayer_image");
            const memeGoalImage = searchParams.get("memegoal_image");
            const memeBgMusic = searchParams.get("memebg_music");
            const memeName = searchParams.get("meme_name");
            
            if (memeBgImage) queryParamData.memebg_image = memeBgImage;
            if (memePlayerImage) queryParamData.memeplayer_image = memePlayerImage;
            if (memeGoalImage) queryParamData.memegoal_image = memeGoalImage;
            if (memeBgMusic) queryParamData.memebg_music = memeBgMusic;
            if (memeName) queryParamData.meme_name = memeName;
        }

        const queryParam = encodeData(queryParamData)
        const gameUrl = `${game?.data?.url}?roomId=${roomCode}&playerId=${userId}&apiUrl=${gameServerUrl}&clientId=${process.env.REACT_APP_CLIENT_ID}&${queryParam}`;

        setGameIframe(gameUrl);
        setShowLobbyRoom(false)
        setShowGameLoadingModal(true)
        setTimeout(() => {
            if (!showGameIframe) {
                setShowGameLoadingModal(false)
                setShowGameIframe(true)
            }
        }, 4000)
    }

    const handlePlayAgain = () => {
        // Re-Register user for PWs
        setPwsPlayers([])
        setShowResultModal(false)
        setMultiplayerGameResults([])
        setIsGameWon(false)
        registerUserInMultiplayerPlayWithStranger()
    }

    useEffect(() => {
        const handleMessageFromParent = (event) => {
            const gameFrame = document.getElementById('timepass-gameframe');
            if (gameFrame && gameFrame.contentWindow && event.source === window.parent) {
                gameFrame.contentWindow.postMessage(event.data, '*');
            }
        };

        window.addEventListener('message', handleMessageFromParent);

        return () => {
            window.removeEventListener('message', handleMessageFromParent);
        };
    }, []);


    const fetchPlayWithStrangerStatus = async (participantID) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_SERVER_URL}/game/multiplayer/${participantID}/matchmaking-status`,
                {
                    headers: {
                        "User-ID": userId,
                        "Client-Id": process.env.REACT_APP_CLIENT_ID,
                        "platform-name": "WEB",
                        "build-number": 1
                    },
                }
            );
            if (response?.data?.data?.id) {
                setGameServerUrl(response.data?.data?.game_server_url)
                setRoomCode(response.data?.data?.id)
                localStorage.setItem("roomCode", response.data?.data?.id)
                setPwsPlayers(response.data?.data?.participants.filter(user => user.user_id !== userId));
            } else {
                setTimeout(() => {
                    fetchPlayWithStrangerStatus(participantID)
                }, 3000)
            }
        } catch (error) {
            toast("Please Try again later. Error fetching status");
            console.error(error)
        }
    }

    const handleShowGameResultModal = async () => {
        setShowResultLoadingModal(true)
        setTimeout(async () => {
            fetchGameResults()
        }, 3000);
    };
    const fetchGameResults = async () => {
        const code = localStorage.getItem("roomCode")
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_SERVER_URL}/multiplayer/room/${code}/game-results`,
                {
                    headers: {
                        "User-ID": userId,
                        "Client-Id": process.env.REACT_APP_CLIENT_ID,
                        "platform-name": "WEB",
                        "build-number": 1
                    },
                }
            );
            setMultiplayerGameResults(response.data.data)
            setShowResultModal(true)
            setShowResultLoadingModal(false)
        } catch (error) {
            toast("Please Try again later. Error fetching status");
            console.error(error)
        }
    }

    const handleExitAfterResults = () => {
        setPwsPlayers([])
        setShowResultModal(false)
        setMultiplayerGameResults([])
        setIsGameWon(false)
        setShowResultModal(false)
        setShowGameIframe(false)
        setShowGameModeModal(true)
    }

    const registerUserInMultiplayerPlayWithStranger = async () => {
        try {
            const res = await registerPlayWithStranger({
                uuid: game?.data?.uuid,
                user_id: userId,
                avatar: avatar,
                name: name
            }).unwrap()
            setJoinPWSResponse(res.data)
            setShowGameModeModal(false)
            setShowLobbyRoom(true)
            if (res.data.participant_id) {
                setTimeout(() => {
                    fetchPlayWithStrangerStatus(res.data.participant_id)
                }, 3000)
            } else {
                setTimeout(() => {
                    setGameServerUrl(res?.data?.game_server_url)
                    setRoomCode(res?.data?.id)
                    localStorage.setItem("roomCode", res?.data?.id)
                    setPwsPlayers(res.data?.participants.filter(user => user.user_id !== userId));
                }, 2000)
            }
        } catch (error) {
            toast("Please Try again later.");
            console.error(error)
        }
    }


    const playWithStrangerStatus = async (uuid) => {
        try {
            const res = await registerPlayWithStranger({uuid, user_id: userId, avatar: avatar, name: name}).unwrap()
            setJoinPWSResponse(res.data)
        } catch (error) {
            toast("Please Try again later.");
            console.error(error)
        }
    }
    const getGamee = async slug => {
        try {
            const access_token=searchParams.get("_portalToken")
            const res = await getGame({slug, access_token}).unwrap()
            return res.data
        } catch (error) {
            console.error(error)
            setError(error.data.message)
        }
    }

    useEffect(() => {
        // Show the loader for 6 seconds
        const loaderTimeout = setTimeout(() => {
            setShowLoader(false)
        }, 2000) // 6 seconds delay in milliseconds

        return () => clearTimeout(loaderTimeout)
    }, [])

    const api_url = process.env.REACT_APP_API_SERVER_URL

    // Helper function to get user ID from various parameter name variations
    const getUserIdFromParams = () => {
        return searchParams.get('user-id') || 
               searchParams.get('User-id') || 
               searchParams.get('user_id') || 
               searchParams.get('User_id') || 
               searchParams.get('userId') || 
               searchParams.get('UserId') || 
               '';
    }

    const getShowInGameControlsFromParams = () => {
        return searchParams.get('show_in_game_controls') === 'true';
    }

    const encodeData = data => {
        return Object.keys(data)
            .map(function (key) {
                return [key, data[key]].map(encodeURIComponent).join('=')
            })
            .join('&')
    }

    function showRewardedAds() {
        window.adBreak({
            type: 'reward'
        })
    }

    useEffect(() => {
        const nameParam = searchParams.get("name");
        const name = names[Math.floor(Math.random() * names.length)];
        setName(nameParam || name);
        const avatarParam = searchParams.get("avatar");
        const randomAvatar = avatarImages[Math.floor(Math.random() * avatarImages.length)];
        setAvatar(avatarParam || randomAvatar);
        setMode(searchParams.get("mode") || "dark");
        setUserId(searchParams.get("userId") || uuidv4());
    }, []);

    // When show_multiplayer_game_modes=false, skip game mode modal and go directly to matchmaking
    useEffect(() => {
        if (
            game?.data?.multiplayer &&
            searchParams.get("show_multiplayer_game_modes") === "false" &&
            !hasAutoJoinedMatchmaking.current
        ) {
            hasAutoJoinedMatchmaking.current = true;
            setShowGameModeModal(false);
            registerUserInMultiplayerPlayWithStranger();
        }
    }, [game?.data]);

    useEffect(() => {
        try {
            getGamee(slug).then(data => {
                if (data) {
                    setThumbnail(data?.property?.thumbnail)
                    const existingGames = JSON.parse(localStorage.getItem('continueGames')) || [];

                    const filteredGames = existingGames.filter(game => game.uuid !== data.uuid);

                    filteredGames.push(data);

                    localStorage.setItem('continueGames', JSON.stringify(filteredGames));
                    window.addEventListener('message', function (event) {
                        console.log(
                            '[Timepass Web] Game -> Platform Call Received: ',
                            event.data.func,
                        )
                        if (
                            event.data.func === 'showAds'
                        ) {
                            showMidrollAd()
                        } else if (
                            event.data.func === 'showPurchaseOptions'
                        ) {
                            setGameProductId(event.data.productId)
                            showRewardedAd(event.data.productId, true)
                        }
                        if (event.source !== window.parent) {
                            if (window.parent) {
                                window.parent.postMessage(event.data, '*');
                            }
                        }
                        if (event.data.func === 'gameOver') {
                            handleShowGameResultModal()
                        }
                        if (event.data.func === 'pageReady') {
                            setShowGameLoadingModal(false)
                            setShowGameIframe(true)
                        }
                    })
                    const searchParams = new URLSearchParams(location.search);
                    const urlParamsData = Object.fromEntries(searchParams.entries());
                    const queryParamData = {
                        game_id: data?.uuid,
                        auth_type: 'basic',
                        score_sync: data?.score_sync,
                        state_sync: data?.state_sync,
                        user_id: getUserIdFromParams(),
                        client_id: process.env.REACT_APP_CLIENT_ID,
                        tournament_mode: searchParams.get("tournament_mode") === "true",
                        show_ads: false,
                        show_purchase_options: process.env.REACT_APP_SHOW_ADS === "true" || (process.env.REACT_APP_SHOW_ADS_FROM_PARAMS === "true" && searchParams.get("showAds") === "true"),
                        show_revive_button: process.env.REACT_APP_SHOW_ADS === "true" || (process.env.REACT_APP_SHOW_ADS_FROM_PARAMS === "true" && searchParams.get("showAds") === "true"),
                        show_share_button: false,
                        show_in_game_controls: getShowInGameControlsFromParams(),
                        is_business_platform: true,
                        data: urlParamsData["data"]
                    }

                    // Add tournament parameters only if they exist in query params
                    const tournamentId = searchParams.get("tournament_id");
                    const tournamentType = searchParams.get("tournament_type");
                    const tournamentChances = searchParams.get("tournament_chances");
                    const tournamentTime = searchParams.get("tournament_time");

                    if (tournamentId) queryParamData.tournament_id = tournamentId;
                    if (tournamentType) queryParamData.tournament_type = tournamentType;
                    if (tournamentChances) queryParamData.tournament_chances = tournamentChances;
                    if (tournamentTime) queryParamData.tournament_time = tournamentTime;

                    // Add meme_mode parameters if meme_mode is enabled and meme_mode=true in query params
                    const memeModeFeatureEnabled = process.env.REACT_APP_MEME_MODE_FEATURE === "true";
                    const memeModeParam = searchParams.get("meme_mode");
                    
                    if (memeModeFeatureEnabled && memeModeParam === "true") {
                        queryParamData.meme_mode = "true";
                        
                        // Extract meme-related query parameters
                        const memeBgImage = searchParams.get("memebg_image");
                        const memePlayerImage = searchParams.get("memeplayer_image");
                        const memeGoalImage = searchParams.get("memegoal_image");
                        const memeBgMusic = searchParams.get("memebg_music");
                        const memeName = searchParams.get("meme_name");
                        
                        if (memeBgImage) queryParamData.memebg_image = memeBgImage;
                        if (memePlayerImage) queryParamData.memeplayer_image = memePlayerImage;
                        if (memeGoalImage) queryParamData.memegoal_image = memeGoalImage;
                        if (memeBgMusic) queryParamData.memebg_music = memeBgMusic;
                        if (memeName) queryParamData.meme_name = memeName;
                    }

                    const queryParam = encodeData(queryParamData)
                    setGameIframe(
                        `${data?.url}?api_url=${api_url}&${queryParam}`
                    )
                    dispatch(setGame(data))
                    if (!location.state) {
                        const properties = {
                            GAME_NAME: data?.name,
                            GAME_FROM: 'Game',
                            GAME_UUID: data?.uuid,
                            SEGMENT_NAME: 'Direct Landing',
                        }
                        sendAnalytics('track', properties, 'Play Game', [
                            'mixpanel',
                            'gtag'
                        ])
                    }

                }
            }).catch(error => {
                console.log(error.data);
            })
        } catch (error) {
            console.error(error)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        const userId = getUserIdFromParams();
        if (userId) {
            sendAnalytics('identify', {}, userId, ['mixpanel'])
        }
    }, [location])
    const notifyPurchaseCompleted = (productId, purchaseType) => {
        const gameFrame = document.getElementById('timepass-gameframe')
        gameFrame.contentWindow.postMessage(
            {
                func: 'purchaseCompletedCallback',
                productId: productId,
                purchaseType: purchaseType
            },
            '*'
        )
    }


    const showPreRollAd = () => {

        if (process.env.REACT_APP_SHOW_ADS ==="true" && process.env.REACT_APP_SHOW_ADS_ON_PLATFORM === "true")
            window.adBreak({
            type: 'preroll',
            name: 'preroll_ad',
            adBreakDone: (info) => {
                console.log(`Preroll result: ${info.breakStatus}`);
            }
        });
    }

    const showMidrollAd = () => {
        if (process.env.REACT_APP_SHOW_ADS ==="true" && process.env.REACT_APP_SHOW_ADS_ON_PLATFORM === "true")
            window.adBreak({
                type: 'next',
                name: 'continue_game',
                adBreakDone: (info) => {
                    console.log(`Next result: ${info.breakStatus}`);
                }
            });
    }


    let lastRewardedAdTime = 0;
    const REWARDED_AD_COOLDOWN_MS = 1000;
    const showRewardedAd = (productId, callAgain = true) => {
        if (process.env.REACT_APP_SHOW_ADS === "true" && process.env.REACT_APP_SHOW_ADS_ON_PLATFORM === "true") {
            const now = Date.now();

            if (now - lastRewardedAdTime < REWARDED_AD_COOLDOWN_MS) {
                return;
            }

            lastRewardedAdTime = now;

            window.adBreak({
                type: 'reward',
                name: 'one_more_chance',

                beforeAd: () => {
                    console.log("Before ad plays...");
                },

                afterAd: () => {
                    console.log("Ad completed. Notifying purchase.");
                    notifyPurchaseCompleted(productId, 'ad');
                },

                beforeReward: (showAdFn) => {
                    console.log("Preparing to show rewarded ad...");
                    showAdFn(); // REQUIRED!
                },

                adDismissed: () => {
                    console.log("User dismissed the ad.");
                },

                adViewed: () => {
                    console.log("User viewed the ad fully.");
                }
            });
            if (callAgain) {
                setTimeout(() => {
                    showRewardedAd(productId, false)
                }, 1200)
            }
        }
    };


    useEffect(() => {
        if (process.env.REACT_APP_SHOW_ADS === "true" && game?.data && !game?.data?.multiplayer) {
            const timer = setTimeout(() => {
                showPreRollAd()
            }, 1000);

            return () => clearTimeout(timer);
        }
    }, [game?.data]);

    useEffect(() => {
        if (showAds && searchParams.get("showAds") === "true" && game.data && !game.data.multiplayer) {
            const timer = setTimeout(() => {
                showPreRollAd()
            }, 1000);

            return () => clearTimeout(timer);
        }
    }, [showAds, game])

    return (
        <div className='mx-auto'>

            {
                showAds &&
                showVideoRewardedAd &&
                process.env.REACT_APP_SHOW_ADS_ON_PLATFORM === "true" &&
                <RewardedAdComponent
                    setShowVideoRewardedAd={setShowVideoRewardedAd}
                    notifyPurchaseCompleted={notifyPurchaseCompleted}
                    gameRewardId={gameProductId}
                />

            }
            {
                showAds && showInterstitialAd && process.env.REACT_APP_SHOW_ADS_ON_PLATFORM === "true" &&
                <InterstitialAdComponent
                    setShowInterstitialAd={setShowInterstitialAd}
                />
            }
            {showLoader && (
                // <Player
                //     src='/animation_llkrpnwl.json'
                //     className='player fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2'
                //     loop
                //     autoplay
                //     style={{height: '200px', width: '200px'}}
                // />
               <div>
                   {slug && <GameLoadingScreen key={slug} slug={slug} thumbnail={thumbnail} />}
               </div>
            )}
            {!showLoader && (
                <div className='p-0 max-w-full'>
                    <Helmet>
                        <title>{`${game?.data?.property?.name} - ${process.env.REACT_APP_TITLE}`}</title>
                        <meta
                            name='description'
                            content={`${game?.data?.property?.subtitle}`}
                        />
                    </Helmet>
                    {process.env.REACT_APP_SHOW_GAME_CONTROL_ICON === "true" && searchParams.get("hide_exit_button") !== "true" && (
                        <div
                            className='fixed z-10'
                            style={getGameControlIconPositionStyle(process.env.REACT_APP_GAME_CONTROL_ICON_POSITION)}
                        >
                            <Draggable>
                                <div className='flex items-center gap-2 bg-black rounded-md'>
                                    <div className='bg-black pl-3 w-full h-full'>
                                        <DragIndicatorIcon/>
                                    </div>
                                    <div
                                        className=' bg-[#EA5402] text-white flex w-fit items-center p-2 cursor-pointer'
                                        onClick={() => {
                                            navigate(-1);
                                            setThumbnail(null)
                                        }}
                                        onTouchStart={() => {
                                            navigate(-1);
                                            setThumbnail(null)

                                        }}>
                                        <CloseIcon height='1.5rem' width='1.5rem'/>
                                        {/* <FaHome color="white" size={20} /> */}
                                    </div>
                                </div>
                            </Draggable>
                        </div>
                    )}
                    {/*/***********Home btn and info ***********************************/}
                    {!game?.data?.multiplayer && (
                        <iframe
                            id="timepass-gameframe"
                            title={slug}
                            className='game-frame no-scrollbar absolute top-0 h-full sm:h-full sm:top-0 left-0 bottom-0 right-0 w-full ml-auto mr-auto overflow-hidden'
                            src={gameIframe}
                            key={gameIframe}
                        />
                    )}

                    {game?.data?.multiplayer && showGameIframe && (
                        <iframe
                            id="timepass-gameframe"
                            title={slug}
                            className='game-frame no-scrollbar absolute top-0 h-[100dvh] w-[100dvw]  sm:top-0 left-0 bottom-0 right-0 ml-auto mr-auto overflow-hidden'
                            src={gameIframe}
                            key={gameIframe}
                        />
                    )}
                    {game?.data?.multiplayer && showLobbyRoom && (
                        <LobbyRoom
                            mode={mode}
                            startPWSGame={startPWSGame}
                            pwsPlayers={pwsPlayers}
                            maxCapacity={game?.data?.multiplayer_config?.max_players}
                            gameThumbnail={game?.data?.property?.thumbnail} name={name}
                            avatar={avatar}/>
                    )}
                    {game?.data?.multiplayer && showGameModeModal && (<GameModeModal mode={mode}
                                                                                     isCreatePWSRoomButtonLoading={false}
                                                                                     gameThumbnail={game?.data?.property?.thumbnail}
                                                                                     handleJoinPlayWithStranger={registerUserInMultiplayerPlayWithStranger}/>)}
                    {game.data.multiplayer && showGameLoadingModal &&
                        <GameLoadingModal mode={mode} thumbnail={game?.data?.property?.thumbnail}

                        />}
                    {showResultModal && <GameResultModal multiplayerGameResults={multiplayerGameResults}
                                                         handlePlayAgain={handlePlayAgain}
                                                         userId={userId}
                                                         handleExitAfterResults={handleExitAfterResults}
                                                         setIsGameWon={setIsGameWon}
                                                         avatar={avatar}/>}

                    {showResultLoadingModal && <ResultLoadingModal/>}

                </div>
            )}
            {isError && <ErrorPage message={error}></ErrorPage>}
        </div>
    )
}

export default Game
